import React, { useContext, useEffect } from 'react';
import { Button, SpaceBetween } from '@amzn/awsui-components-core';
import { MplServiceClientFactory } from '../../../api/MplServiceClientFactory';
import { pgsFilter } from '../../../api/ContentUtil';
import { buildTableItems } from '../../workflow-viewer/ContentWorkflowTableDefinitions';
import { ContentQueryContext } from './ContentQueryContext';
import { DateTime } from 'luxon';

const mplService = MplServiceClientFactory.create();

export function AllContentsTableDataProvider() {
  const { queryState, dispatchQueryState } = useContext(ContentQueryContext);

  const handleRefreshClick = () => {
    dispatchQueryState({
      queryTimestamp: DateTime.now(),
      isExecutingQuery: true,
    });
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        dispatchQueryState({
          isExecutingQuery: true,
        });
        const [allContentsResponse, notesResponse, allSharedContents] = await Promise.all([
          mplService.getAllWorkflows(),
          mplService.getContentNoteStats(),
          mplService.listAllSharedContents(),
        ]);

        const contentCoauthorMap = new Map<string, string[]>(Object.entries(allSharedContents));

        const filteredWorkflows = pgsFilter(allContentsResponse.workflows);
        let noteStats: Map<string, number> = new Map();
        if (notesResponse.contentNoteStats) {
          noteStats = new Map(
            notesResponse.contentNoteStats.map((noteStat) => [
              noteStat.contentId,
              noteStat.notesCount,
            ]),
          );
        }
        const tableItems = buildTableItems(filteredWorkflows, { noteStats, contentCoauthorMap });
        dispatchQueryState({
          isExecutingQuery: false,
          queryResult: tableItems,
        });
      } catch (e) {
        dispatchQueryState({
          isExecutingQuery: false,
          queryResult: [],
          // @ts-expect-error TS18046 - strict migration
          queryError: e.message,
        });
      }
    };

    loadData();
  }, [queryState.queryTimestamp, dispatchQueryState]);

  return (
    <SpaceBetween direction="horizontal" size={'s'}>
      <Button
        variant="icon"
        iconName="refresh"
        ariaLabel="Refresh table"
        loading={queryState.isExecutingQuery}
        onClick={handleRefreshClick}
      />
    </SpaceBetween>
  );
}
